var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvironment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.215 39.7752C15.2603 31.0513 16.2623 23.4838 17.3895 14.7215C17.421 14.4793 17.4593 14.2198 17.6153 14.0465C17.7855 13.8568 18.048 13.8245 18.2888 13.8028C27.2408 13.0093 36.2288 12.7123 45.207 12.9133C45.5078 12.92 45.96 11.5378 46.17 11.7778C46.3328 11.9638 46.3793 12.236 46.4183 12.4925C47.2995 18.332 47.826 24.2368 47.9963 30.155C48.0825 33.1438 48.0773 36.1355 47.9813 39.1242C47.9003 41.6375 48.147 44.7312 47.1495 47.027C46.536 48.4377 45.4883 49.4817 44.2043 50.1208C42.6938 50.8715 41.0175 51.0762 39.372 51.2712C35.6528 51.7122 31.9335 52.1532 28.2143 52.5942C25.431 52.9242 22.3425 53.1657 20.1143 51.2848C18.351 49.796 17.5538 47.303 17.0385 44.9105C16.6733 43.2102 16.404 41.4972 16.215 39.7752Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0583 12.2923L45.8446 12.3365L40.0141 12.7858L36.4681 13.0243C28.8211 13.553 23.7998 13.7113 18.3263 13.667H17.3588L17.3986 13.9055C17.8748 18.5938 17.7638 23.009 17.1451 30.86L16.7011 36.2435L16.5826 37.4593C16.1063 43.7338 16.0036 47.822 16.3291 51.902L16.3688 52.466L22.8893 52.6685L25.9831 52.748C34.6538 52.9858 40.1108 52.9858 46.3456 52.7045L47.0753 52.661H47.2178L47.5508 47.2423L47.7646 43.0385C48.1298 36.3238 48.2723 31.7495 48.2408 26.8513V25.0258C48.3166 21.0515 47.9483 17.0825 47.1458 13.2088C47.1053 12.9095 46.9898 12.6283 46.8128 12.398H46.7333C46.5173 12.3095 46.2871 12.2735 46.0583 12.2923Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.373 43.0437C27.327 43.2342 31.2218 43.3317 34.9088 43.3317C37.4513 43.3317 39.9728 43.286 42.4028 43.1952",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3378 35.801C25.3951 36.1392 27.4598 36.308 29.5066 36.308C33.7006 36.308 37.8586 35.6112 41.8658 34.2365L41.8673 34.2417",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 27.602C26.0303 27.9193 28.7513 28.079 31.4423 28.079C35.0783 28.079 38.7466 27.7873 42.3458 27.212",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4916 19.079C27.5513 20.1695 31.6808 20.7252 35.8126 20.7252H35.8133C38.0086 20.7252 40.2263 20.5662 42.4043 20.2542",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvironment);
export default __webpack_public_path__ + "static/media/icon-environment.ccf4fb8ad0d4055e5b9f8d85e1fa44c8.svg";
export { ForwardRef as ReactComponent };